import React, { useState, useEffect } from "react"
import { Nav, TabContent, TabPane, NavLink, CardBody, Card } from "reactstrap"
import SelectLayout from "./selectLayout"
import Media from "./media"
import { FormSection, reduxForm } from "redux-form"
import { FORM_NAMES } from "constants/index"
import { connect } from "react-redux"
import { getMediaGalleryDesign } from "store/actions"
import PropTypes from "prop-types"
import MenuFeatureHyperlinks from "../menuFeatureHyperlinks"
import { LoadingIndicator } from "components/LoadingIndicator"

let MediaGallery = props => {
  useEffect(() => {
    props.getMediaGalleryDesign({
      menu_item_id: props?.feature?.id,
      dashboard: true,
      ...(props?.selectedEvent ? { event_id: props.selectedEvent.id } : {}),
    })
  }, [])

  const TABS = {
    SELECT_LAYOUT: 1,
    MEDIA: 2,
    HYPERLINKS: 3,
  }
  const [activeTab, setActiveTab] = useState(TABS.SELECT_LAYOUT)
  const markAsActive = tab => {
    return activeTab === tab ? "active" : ""
  }
  return (
    <React.Fragment>
      {props?.loading ? (
        <LoadingIndicator />
      ) : (
        <Card>
          <CardBody className="shadow-sm p-1">
            <Nav pills tabs>
              <NavLink
                className={markAsActive(TABS.SELECT_LAYOUT)}
                onClick={() => setActiveTab(TABS.SELECT_LAYOUT)}
              >
                Select Layout
              </NavLink>
              <NavLink
                className={markAsActive(TABS.MEDIA)}
                onClick={() => setActiveTab(TABS.MEDIA)}
              >
                Add/View Media
              </NavLink>
              {props?.isEventFeature &&
                (!!props?.vendorConfig?.nfc_hyperlinks ||
                  !!props?.vendorConfig?.communication_hyperlinks) && (
                  <NavLink
                    className={markAsActive(TABS.HYPERLINKS)}
                    onClick={() => setActiveTab(TABS.HYPERLINKS)}
                  >
                    Hyperlinks
                  </NavLink>
                )}
            </Nav>
            <TabContent activeTab={activeTab}>
              <TabPane tabId={TABS.SELECT_LAYOUT} style={{ animation: "none" }}>
                <FormSection name={`${props.form}`}>
                  <SelectLayout feature={props.feature} />
                </FormSection>
              </TabPane>
              <TabPane tabId={TABS.MEDIA} style={{ animation: "none" }}>
                <Media feature={props.feature} />
              </TabPane>
              {props?.isEventFeature &&
                (!!props?.vendorConfig?.nfc_hyperlinks ||
                  !!props?.vendorConfig?.communication_hyperlinks) && (
                  <TabPane
                    tabId={TABS.HYPERLINKS}
                    style={{ animation: "none" }}
                  >
                    <MenuFeatureHyperlinks
                      event_id={props?.selectedEvent?.id}
                      menu_feature={props?.feature}
                    />
                  </TabPane>
                )}
            </TabContent>
          </CardBody>
        </Card>
      )}
    </React.Fragment>
  )
}

MediaGallery = reduxForm({
  form: FORM_NAMES.MEDIA_GALLERY,
  initialValues: { media_gallery_form: { layout: "1" } },
})(MediaGallery)

const mapStateToProps = state => ({
  selectedEvent: state.experiences.selectedEvent,
  vendorConfig: state.clients.vendorConfig,
  loading: state.MediaGallery.loading,
})

const mapDispatchToProps = dispatch => ({
  getMediaGalleryDesign: values => dispatch(getMediaGalleryDesign(values)),
})

MediaGallery.propTypes = {
  feature: PropTypes.object,
}

export default connect(mapStateToProps, mapDispatchToProps)(MediaGallery)
